import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { font } from '@styles/fonts';

import { LeftPartType } from '@v2/elements/Fields/interfaces';
import { scale } from '@components/frame';

export default ({ LEFT_PART_WIDTH, C, name }: LeftPartType) => {
  return (
    <View style={{ width: LEFT_PART_WIDTH }}>
      <Text numberOfLines={1} style={[font.Body, { color: C('Label/Light/Primary') }]}>
        {i18n.t(name)}
      </Text>
    </View>
  );
};
